import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Table, Form, Segment, Button, Divider, } from 'semantic-ui-react';
import { serverIp, toCurrency } from '../../../../config/constants.js'
import axios from 'axios'
import Select from 'react-select';
//import { getPrintValues } from './newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getPrintValues } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';

class BeyonicDeduction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deductAmount:'',
            deductReason:'',
            deductList:[]
        }
    }


    componentDidMount () {
        console.log("ddx13 ++++++ componentDidMount ");

        getPrintValues("beyonicDeduction", this.loadDeductionList);
    }

    loadDeductionList = (deductList) => {
        //console.log("ddx12 ++++++ loadDeductionList ");
       // console.log("ddx121 deductList:"+JSON.stringify(deductList, null, 3));
        this.setState({deductList:deductList})
    }


    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    handleDropDownChanges = (value) => {
        console.log("handleDropDownChanges");
        console.log('ddx33 You\'ve sss:', value);
        console.log('ddx331 You\'ve selected:', value.value + " " + value.category);

        //this.setState(newState);
        this.setState({
            deductReason: value.value
        });
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    sendDeduction = () => {
        console.log("++++++++:sendDeduction");
        console.log("new state item array:");
        console.log("date:" + this.state.dateNum);

        axios.post(serverIp + 'billing/beyonicDeduction', {
            apiKey: "ad#4fsdUUddf",
            amountDep: this.state.deductAmount,
            reason: this.state.deductReason,
            dateRequired: this.state.dateNum,
            adminEmail: this.props.user.email
        })
            .then((response) => {
                console.log(response.data);

                console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    alert("deduction sent.");
                    this.setState({
                        deductAmount:'',
                        deductReason:'',
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });

    }


    render() {

        const submitButton = this.state.deductAmount !== '' && this.state.deductReason !== ''
        ? <Button color='teal'>SEND</Button>
        :''

        return (<div>
            <Segment>
                <Form fixed onSubmit={this.sendDeduction}>
                    <SingleDatePicker
                        date={this.state.date} // momentPropTypes.momentObj or null
                        //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                        onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        isOutsideRange={() => false}
                        onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    />
                    <br/>
                    {/* <Form.Field>
                        <Form.Input
                            name={'deductReason'}
                            value={this.state.deductReason}
                            placeholder='Reason For Deduct:'
                            onChange={this.handleTextInputChange}
                            type='text' 
                        />
                    </Form.Field> */}

                    <Select
                        name="form-field-name"
                        value={this.state.deductReason}
                        options={this.state.deductList}
                        onChange={this.handleDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />


                    <Form.Field>
                    <label>{toCurrency(this.state.deductAmount)}</label>
                        <Form.Input
                            name={'deductAmount'}
                            value={this.state.deductAmount}
                            placeholder='Amount To Deduct:'
                            onChange={this.handleTextInputChange}
                            type='number'
                        />
                    </Form.Field>

                    {submitButton}
                </Form>
            </Segment>
        </div>);
    }
}

export default BeyonicDeduction;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/BeyonicDeduction.js